import { render, staticRenderFns } from "./DashboardTest.vue?vue&type=template&id=98e956aa&scoped=true"
import script from "./DashboardTest.vue?vue&type=script&lang=js"
export * from "./DashboardTest.vue?vue&type=script&lang=js"
import style0 from "./DashboardTest.vue?vue&type=style&index=0&id=98e956aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e956aa",
  null
  
)

export default component.exports